import { useState } from 'react';
import { useApiFetch } from './api/useApiFetch';

interface IYandexMapTokens {
    geocoder: string;
    suggest: string;
}

export const useYandexMapToken = () => {
    const api = useApiFetch();
    const [data, setData] = useState<IYandexMapTokens>();
    const [loading, setLoading] = useState(false);

    const getTokens = async () => {
        setLoading(true);

        const response = await api.fetchData<IYandexMapTokens>('/yandex/map/token', 'get', true);

        if (response.success && response.data instanceof Object) {
            setData(response.data);
        }

        setLoading(false);

        return response.data;
    };

    return {
        getTokens,
        loading,
        tokens: data,
    };
};
